import React from 'react';
import { __ } from '../../Lang.js';

const VideoLoadingState = () => {
  return (
    <div className="video-loading-container">
      <div className="video-spinner"></div>
      <p className="video-loading-text">{ __('Loading Videos...') }</p>
    </div>
  );
};

export default VideoLoadingState;